import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
const ButtonGroupRoot = styled.div `
  display: inline-flex;
  border-radius: 0.375rem;
  isolation: isolate;
`;
const ButtonGroupCustomButton = styled.button `
  position: relative;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 5px;
  padding-bottom: 5px;
  border-width: 1px;
  border-top-left-radius: ${({ isLast }) => !isLast && '0.375rem'};
  border-bottom-left-radius: ${({ isLast }) => !isLast && '0.375rem'};

  border-top-right-radius: ${({ isLast }) => isLast && '0.375rem'};
  border-bottom-right-radius: ${({ isLast }) => isLast && '0.375rem'};
  margin-left: ${({ isLast }) => isLast && '-1px'};
`;
export function ButtonGroup(props) {
    const { children } = props;
    return _jsx(ButtonGroupRoot, { children: children });
}
ButtonGroup.Button = function ButtonGroupButton(props) {
    const { position, label, onClick } = props;
    return (_jsx(ButtonGroupCustomButton, { type: "button", onClick: onClick, isLast: position === 'last', children: label }));
};
//# sourceMappingURL=ButtonGroup.js.map